import React from "react";
import st from "../../style.module.scss";
import { useFieldArray } from "react-hook-form";
import { Form } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import { FaRegCircle } from "react-icons/fa";

export default ({ nestIndex, control, register, errors, getValues }) => {

  const { fields, remove, append } = useFieldArray({
    control,
    name: `form.${nestIndex}.nestedOptions`,
  });

  return (
    <div>
      <div className="row mt-2">
        <div className="col-6" style={{paddingLeft:"70px"}}><Form.Label>Option</Form.Label></div>
        <div className="col-5"><Form.Label>Score</Form.Label></div>
        <div className="col-1 px-0"><Form.Label>Action</Form.Label></div>
      </div>
      {fields.map((item, k) => {
        return (
          <div key={item.id} style={{ marginLeft: 20 }}>
            <Form.Group
              className={`${st.formField} ${st.new_formFields} d-flex`}
            >
              <span className="btn">
                <FaRegCircle />
              </span>
              <div>
                <Form.Control
                  type="text"
                  placeholder="Option"
                  {...register(`form.${nestIndex}.nestedOptions.${k}.Option`, {
                    required: "Option is required",
                    setValueAs: (op) => ({ label: op, value: op }),
                  })}
                />
                {errors.form?.[nestIndex]?.nestedOptions?.[k]?.Option?.message && <span className="text-danger">This field is required</span>}
              </div>
              <div>
                <Form.Control
                  type="number"
                  placeholder="Score"
                  {...register(`form.${nestIndex}.nestedOptions.${k}.score`, {
                    required: "Score is required",
                  })}
                />
                {errors.form?.[nestIndex]?.nestedOptions?.[k]?.score?.message && <span className="text-danger">This field is required</span>}
              </div>
             
              <button className="btn" type="button" onClick={() => remove(k)}>
                <MdDelete />
              </button>
            </Form.Group>
          </div>
        );
      })}

      <div>
        <Form.Group className={`${st.formField} ${st.new_formFields} d-flex`}>
          <div className={`${st.tableAction} mb-0`}>
            <button
              style={{ color: "#fff", background: "#7f8699" }}
              type="button"
              className={`btn`}
              onClick={() =>
                append({
                  Option: "",
                  score: ""
                })
              }
            >
              Add Option
            </button>

          </div>
        </Form.Group>
      </div>
      
    </div>
  );
};
